import api from "./apiBase";
import { getOrCreateDeviceId } from "@/utils/deviceId";

function withDeviceId() {
  return {
    headers: {
      "x-device-id": getOrCreateDeviceId(),
    },
  };
}

function loginUser(email, password, claimSessionToken) {
  const body = { email, password };
  if (claimSessionToken) body.claimSessionToken = claimSessionToken;
  return api.post("/auth/login", body, withDeviceId());
}

function logoutUser() {
  return api.post("/auth/logout");
}

function getUser() {
  return api.get("/auth/me");
}

function getCodeOTP() {
  return api.get("/email-verification");
}

function verifyCodeOTP(code) {
  return api.post("/email-verification", { code });
}

function verifyEmailAvailable(email) {
  return api.get("/auth/verify?email=" + email);
}

function verifyUsernameAvailable(username) {
  return api.get("/auth/verify?username=" + username);
}

function resetPassword(email) {
  return api.post("/auth/reset-password", { email });
}

function validateResetPassword(query) {
  return api.get(`/auth/reset/validate?q=${query}`);
}

function confirmResetPassword(payload) {
  return api.post("/auth/reset/confirm", payload);
}

function redefinePassword(token, payload) {
  return api.patch("auth/password/new", payload, {
    headers: {
      "Content-Type": "application/json",
      "x-mm-token": token,
    },
  });
}

export {
  loginUser,
  logoutUser,
  getUser,
  getCodeOTP,
  verifyCodeOTP,
  verifyEmailAvailable,
  verifyUsernameAvailable,
  resetPassword,
  validateResetPassword,
  redefinePassword,
  confirmResetPassword,
};
